import React from 'react';
import PropTypes from 'prop-types';
import { pie, lineGraphic, barGraphic } from 'constants/indicatorTypes';
import { Card } from '@totalsoft/rocket-ui';
import DashboardDoughnutChart from './charts/DashboardDoughnutChart';
import { DashboardChartCardContainer } from './DashboardStyles';
import DashboardLineChart from './charts/DashboardLineChart';
import DashboardBarChart from './charts/DashboardBarChart';

const DashboardIndicatorComponent = ({ indicator }) => {
  return (
    <>
      {indicator.type === pie && (
        <DashboardChartCardContainer item lg={6} xs={12}>
          <DashboardDoughnutChart indicator={indicator} />
        </DashboardChartCardContainer>
      )}

      {indicator.type === lineGraphic && (
        <DashboardChartCardContainer item lg={12} xs={12}>
          <DashboardLineChart indicator={indicator} />
        </DashboardChartCardContainer>
      )}

      {indicator.type === barGraphic && (
        <DashboardChartCardContainer item lg={12} xs={12}>
          <Card title={indicator.title}>
            <DashboardBarChart indicator={indicator} />
          </Card>
        </DashboardChartCardContainer>
      )}
    </>
  );
};

DashboardIndicatorComponent.propTypes = {
  indicator: PropTypes.object.isRequired
};

export default DashboardIndicatorComponent;
